import { Component, OnInit } from '@angular/core';

import { EduChatUser } from '@app/models';
import { EmailSenderService, SharedUtilsService } from '@app/services';

@Component({
    selector: 'custom-edu-chat-window',
    templateUrl: './custom-edu-chat-window.component.html',
    styleUrls: ['./custom-edu-chat-window.component.scss'],
    standalone: false
})
export class CustomEduChatWindowComponent implements OnInit {
  chatUser: EduChatUser = null;
  chatWindowOpened: boolean = false;
  someoneAvailableToChat: boolean = false;
  formTitle: string = '';
  formMessage: string = '';
  formButtonText: string = '';
  errorMessage: string = null;
  validForm: boolean = false;
  formChecked: boolean = false;
  phoneMask;

  constructor(
    private _emailSenderService: EmailSenderService,
    private _sharedUtilsService: SharedUtilsService
  ) {
    this.phoneMask = this._sharedUtilsService.phoneMask;
  }

  ngOnInit() {
    this.checkIfSomeoneIsAvaliable();
  }


  listenForLiveChatAvailability() {
    //! Will need to listen if availability has changed for live chat
  }


  checkIfSomeoneIsAvaliable() {
    // Text and fields change if nobody is available. At lunch it changed from now chatting layout to contact us with send message.
    if (this.someoneAvailableToChat) {
      this.formTitle = 'Now Chatting';
      this.formMessage = 'Hi! Let\'s get some quick info so we can better serve you:';
      this.formButtonText = 'Start Chatting';
    } else {
      this.formTitle = 'Contact Us!';
      this.formMessage = 'We\'re not around but we still want to hear from you! Leave us a note:';
      this.formButtonText = 'Send';
    }
  }


  resetChat() {
    this.chatWindowOpened = false;
    this.formChecked = false;
    this.validForm = false;
    this.errorMessage = null;
    this.chatUser = null;
  }


  openChat() {
    this.chatWindowOpened = true;
    this.chatUser = new EduChatUser();
  }


  closeChat() {
    this.resetChat();
  }


  checkForm() {
    let passesChecks = true;
    if ((!this.chatUser.name || this.chatUser.name === '') || (!this.chatUser.email || this.chatUser.email === '') ||
      (this.someoneAvailableToChat && (!this.chatUser.phone || this.chatUser.phone === '')) || 
      (!this.someoneAvailableToChat && (!this.chatUser.message || this.chatUser.message === ''))) passesChecks = false;

    this.validForm = passesChecks;
  }


  async submitForm() {
    this.formChecked = true;
    this.checkForm();

    if (!this.validForm) {
      this.errorMessage = 'Please complete all required fields';
      return;
    }

    // Send email and wait for response
    const emailResponse = await this._emailSenderService.contactUs(this.chatUser).toPromise();
    if (emailResponse != undefined && !emailResponse['error']) {
      this._sharedUtilsService.showNotification('Thank you. Your form was successfully sent and we will contact you as soon as possible.');
      this.resetChat();
    } else if (emailResponse != undefined && emailResponse['error']) {
      this._sharedUtilsService.showErrorDialog(emailResponse['error']);
    } else {
      this._sharedUtilsService.showErrorDialog('There was an issue sending this email. Please try again later.');
    }
  }
}